import './Loader.scss';

import cn from 'classnames';
import lottie from 'lottie-web';
import React, { useEffect, useRef } from 'react';

import { ROUTE_SCANBAT } from '@/common/constants';
import scanbatLoader from '@/ebat/assets/loader/loader-scanbat.json';
import loader from '@/ebat/assets/loader/loader-small.json';

import { LoaderDefaultProps, LoaderPropTypes } from './Loader.proptypes';

const Loader = ({ className, type }) => {
  const loaderRef = useRef(null);
  const isScanbat = window.location.pathname.includes(ROUTE_SCANBAT);

  useEffect(() => {
    if (loaderRef.current) {
      lottie.loadAnimation({
        container: loaderRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: isScanbat ? scanbatLoader : loader,
      });
    }
  }, [isScanbat]);

  return (
    <div
      className={cn('loader', className, { [`loader--${type}`]: type })}
      data-qa-id="loader"
    >
      <div
        ref={loaderRef}
        className={cn('loader__item', { 'loader__item-scanbat': isScanbat })}
      />
    </div>
  );
};

Loader.defaultProps = {
  ...LoaderDefaultProps,
};

Loader.propTypes = {
  ...LoaderPropTypes,
};

export default Loader;
